import { logger } from "@utilities";
import axios from "axios";
import queryString from "query-string";
import { logout, resetSavedCart, setSignIn, setJwt, store } from "@redux";
import { protectedPath } from "../Routes/index";
import { PATH_HOME } from "@routes";
import { ssPathname } from "../Utilities/storage";
import { authApi } from "./authApi";

const authClientV2 = axios.create({
    baseURL: process.env.REACT_APP_API_URL_V2,

    headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
    },

    paramsSerializer: (params) => queryString.stringify(params),
});

authClientV2.interceptors.request.use((config) => {
    const state = store.getState();
    const signInToken = state.signIn.signIn?.data.accessToken || state.auth?.jwt?.accessToken;
    if (signInToken) {
        config.headers.Authorization = `Bearer ${signInToken}`;
    }
    return config;
});

authClientV2.interceptors.response.use(
    (response) => {
        // Pass through successful responses
        return response;
    },
    async (error) => {
        const originalRequest = error.config;

        // Handle 401 Unauthorized errors
        if (error.response && error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                const state = store.getState();
                if (!state.auth?.jwt?.accessToken && !state.signIn.signIn?.data.accessToken) {
                    return Promise.reject(error);
                }
                const userId = state.account?.account?.id;
                const refreshToken = state.signIn.signIn?.data.refreshToken || state.auth?.jwt?.refreshToken;
                const refreshResponse = await authApi.refresh({
                    user_id: userId,
                    refresh_token: refreshToken,
                });
                const newAccessToken = refreshResponse.data.data.accessToken;
                store.dispatch(
                    setSignIn({
                        ...store.getState().signIn.signIn,
                        data: {
                            ...store.getState().signIn.signIn?.data,
                            accessToken: newAccessToken,
                        },
                    }),
                );
                const currentJwt = store.getState().auth?.jwt;
                if (currentJwt) {
                    store.dispatch(setJwt({ ...currentJwt, accessToken: newAccessToken }));
                }
                originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
                return authClientV2(originalRequest);
            } catch (refreshError) {
                const current = window.location.pathname;
                const isProtectedRoute =
                    current === PATH_HOME || protectedPath.some((item) => current.includes(item));

                if (isProtectedRoute) ssPathname.setItem(current + window.location.search);
                store.dispatch(logout());
                store.dispatch(resetSavedCart());
                console.error("Token refresh failed:", refreshError);
                return Promise.reject(refreshError);
            }
        }

        if (error.response && ![404, 400].includes(error.response.status)) {
            logger.apiError(window.location.href, error.response);
        }

        throw error;
    },
);

export default authClientV2;
